<template>
  <div id="tutorials-tab" align="center">
    <div class="section-top m-t-20">
      <div class="head-section">
        <h4 class="section-title">
          <span>{{ $t('UserKit.tutorials_tab.manager.destination_managers') }}</span>
        </h4>
      </div>

      <div class="content-section m-t-15">
        <div class="row">
          <div class="col-md-6 col-lg-4 item-wrapper" v-for="item in tutorial_manager">
            <tutorial-item :youtubeUrl="item.youtubeUrl" :description="item.description" />
          </div>
        </div>
      </div>
    </div>

    <div class="section-bottom m-t-20">
      <div class="head-section">
        <h4 class="section-title">
          <span>{{ $t('UserKit.tutorials_tab.candidate.destination_candidate') }}</span>
        </h4>
      </div>

      <div class="content-section m-t-15">
        <div class="row">
          <div class="col-md-6 col-lg-4 item-wrapper" v-for="item in tutorial_candidate">
            <tutorial-item :youtubeUrl="item.youtubeUrl" :description="item.description" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TutorialItem from './TutorialItem'

  export default {
    name: "TutorialsTab",
    components: {
      TutorialItem
    },
   
    data() {
      return {
        tutorial_manager: [
          {
            youtubeUrl: 'https://www.youtube.com/embed/44_14m7rg9k',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.understanding_dashboard')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/Iw5MC4XZHps',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_create_manager')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/JlNNjUQv8XE',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_create_replacement')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/DFg4R7Kj8sg',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_select_candidates_in_offer')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/pOshvWq3AE8',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_manage_replacement')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/yaFYJy4gXLo',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_respond_application')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/26SeqNcA0BQ',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_add_candidate_to_team')
          },

          {
            youtubeUrl: 'https://www.youtube.com/embed/vF-_KDv-jQg',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_manage_team')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/yRVM1Y4OJwg',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_check_candidate_schedule')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/YOWHpAO2MeA',
            description: this.$i18n.t('UserKit.tutorials_tab.manager.how_analyze_statistics')
          }
        ],
        tutorial_candidate: [
          {
            youtubeUrl: 'https://www.youtube.com/embed/awTS1qXUSgk',
            description: this.$i18n.t('UserKit.tutorials_tab.candidate.how_register')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/N8FdSvoDwm8',
            description: this.$i18n.t('UserKit.tutorials_tab.candidate.how_manage_agenda')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/jihSBY2-JDA',
            description: this.$i18n.t('UserKit.tutorials_tab.candidate.how_manage_solicitation_preferences')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/cga9-WeQ89I',
            description: this.$i18n.t('UserKit.tutorials_tab.candidate.how_accept_or_refuse_replacement')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/5FNo1dBarzk',
            description: this.$i18n.t('UserKit.tutorials_tab.candidate.how_logout')
          },
          {
            youtubeUrl: 'https://www.youtube.com/embed/ABwyKWRT4ls',
            description: this.$i18n.t('UserKit.tutorials_tab.candidate.how_change_password')
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  $color-line: #ddd !default;

  #tutorials-tab {
    .section-title {
      width: 100%;
      text-align: left;
      border-bottom: 1px solid $color-line;
      line-height: 0.1em;
      margin: 30px 0 25px;
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 14px;
      span {
        background: #fff;
        padding: 0 10px 0 0;
        text-transform: uppercase;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userKit/TutorialsTab.vue